// extracted by mini-css-extract-plugin
export default {"toggle":"OutputSettings_toggle__v5-Bs","active":"OutputSettings_active__GehRF","dropdown":"OutputSettings_dropdown__YC3Me","button":"OutputSettings_button__6wf0K"};